import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import PopOver from "../../global/PopOver";
import { toast } from "react-toastify";
import Loader from "../../Layout/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import bigDecimal from "js-big-decimal";

const FinalizeInvoice = ({ fullCompany, posState, swal, approveInvoice, onClose, isEditPos = false, isCorrective }) => {
  const { t } = useTranslation("translations");
  let isSimple = posState.paymentMeans == "10" && !isCorrective;

  const [recivedAmount, setRecievedAmount] = useState();
  const [finalState, setFinalState] = useState(posState);
  const [loading, setLoading] = useState(false);

  const addAmount = (value) => {
    setRecievedAmount((amount) => bigDecimal.add(amount, value));
  };

  const allArr = [100, 200, 500, 1000, 2000, 5000];
  const eurUsdArr = [1, 2, 5, 10, 20, 50];
  let cashArray = allArr;
  let currency = "L";
  if (posState.currency == "EUR") {
    currency = "€";
    cashArray = eurUsdArr;
  } else if (posState.currency == "USD") {
    currency = "$";
    cashArray = eurUsdArr;
  }

  const handleChange = (key, val, trim = false) => {
    let value = val;
    if (trim) value = value.trim();
    setFinalState((posState) => ({
      ...posState,
      [key]: value,
    }));
  };

  const innerRef = useRef();
  useEffect(() => {
    setTimeout(() => {
      innerRef.current && innerRef.current.select();
    }, 10);
  }, []);

  let change = bigDecimal.subtract(recivedAmount, finalState?.invoiceTotalWithVat);

  const approve = () => {
    if (change.includes("-") && isSimple) {
      toast.error(t(["pos.changeValidation"]), {
        containerId: "all_toast",
      });
      return;
    }
    setLoading(true);
    approveInvoice({ invoiceState: finalState });
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else if (swal) {
      swal.close();
    }
  };

  return (
    <div className="finalize-card">
      {/* Header */}
      <div className="finalize-header d-flex align-items-center justify-content-between">
        <div style={{ width: 32 }} />
        <h2>{t("pos.finalizeInvoice")}</h2>
        <button
          onClick={handleClose}
          className="btn btn-sm"
          style={{ color: "white", opacity: 0.8, fontSize: "1.1rem", padding: "0.25rem 0.5rem" }}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>

      {/* Amount Display */}
      <div className="finalize-amount">
        <div className="amount-label">{t("pos.payingAmount")}</div>
        <div className="amount-value">
          {finalState?.invoiceTotalWithVat} {currency}
        </div>
      </div>

      {/* Body */}
      <div className="finalize-body">
        <div className="row">
          <div className={`${isSimple ? "col-lg-10 col-md-9" : "col-12"}`}>
            <div className="row g-3">
              <div className="col-md-4">
                <label className="form-label">
                  {fullCompany?.companyAttributes?.find(a => a?.attribute?.param == "internalId")?.value ?? t("home.internalId")}
                  <PopOver title={fullCompany?.companyAttributes?.find(a => a?.attribute?.param == "internalId")?.value ?? t("hints.internalId")} />
                </label>
                <input
                  type="text"
                  name="internalId"
                  className="form-control"
                  value={finalState?.internalId || ""}
                  onChange={(e) => handleChange("internalId", e.target.value, true)}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">
                  {fullCompany?.companyAttributes?.find(a => a?.attribute?.param == "AdditionalId1")?.value ?? (t("pos.additional") + " 1")}
                </label>
                <input
                  type="text"
                  name="param1"
                  value={finalState?.param1 || ""}
                  className="form-control"
                  onChange={(e) => handleChange("param1", e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">
                  {fullCompany?.companyAttributes?.find(a => a?.attribute?.param == "AdditionalId2")?.value ?? (t("pos.additional") + " 2")}
                </label>
                <input
                  type="text"
                  name="param2"
                  value={finalState?.param2 || ""}
                  className="form-control"
                  onChange={(e) => handleChange("param2", e.target.value)}
                />
              </div>
              <div className="col-12">
                <label className="form-label">{t("pos.paymentNote")}</label>
                <textarea
                  id="payment_note"
                  rows="5"
                  className="form-control"
                  name="payment_note"
                  value={finalState?.paymentNote || ""}
                  onChange={(e) => handleChange("paymentNote", e.target.value)}
                ></textarea>
              </div>

              {/* Cash Section */}
              {isSimple && (
                <div className="col-12">
                  <div className="finalize-cash-section">
                    <div className="text-center">
                      <label className="form-label mb-1 font-weight-bold">{t("pos.recievedAmount")}</label>
                      <input
                        type="number"
                        ref={innerRef}
                        value={recivedAmount}
                        className="arrow-none finalize-cash-input"
                        onChange={(e) => {
                          let value = e.target.value;
                          if (value.split(".")[1]) {
                            value = value.split(".");
                            value = value[0] + "." + value[1].slice(0, 2);
                          }
                          setRecievedAmount(value);
                        }}
                        required
                      />
                    </div>
                    <div className="text-center">
                      <label className="form-label mb-1 font-weight-bold">{t("pos.change")}</label>
                      <div className="finalize-change-display">
                        {(change.includes("-") ? "0" : change) + currency}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Approve Button */}
              <div className="col-12 d-flex justify-content-end mt-2">
                <button
                  onClick={handleClose}
                  type="button"
                  className="btn btn-outline-secondary me-2"
                  style={{ borderRadius: "8px", padding: "0.625rem 1.5rem" }}
                >
                  {t("common.cancel") || "Cancel"}
                </button>
                <button
                  onClick={approve}
                  id="submit-btn"
                  type="button"
                  disabled={loading}
                  className="btn btn-primary btn-lg"
                  style={{ borderRadius: "8px", padding: "0.625rem 2rem", fontSize: "0.95rem" }}
                >
                  {loading ? (
                    <Loader size="xs" color="white" />
                  ) : (
                    <>
                      <FontAwesomeIcon icon={faCheck} className="me-2" />
                      {t("status.approve")}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>

          {/* Quick Cash Buttons */}
          {isSimple && (
            <div className="col-lg-2 col-md-3 quick-cash-section">
              <h4>{t("pos.quickCash")}</h4>
              {cashArray.map((value) => {
                return (
                  <button
                    key={value}
                    onClick={() => addAmount(value)}
                    className="btn btn-block btn-lg btn-primary mb-2 qc-btn sound-btn"
                    type="button"
                  >
                    {value} {currency}
                  </button>
                );
              })}
              <button
                onClick={() => setRecievedAmount(0)}
                className="btn btn-block btn-danger btn-lg qc-btn sound-btn"
                type="button"
              >
                Clear
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FinalizeInvoice;
